// in src/posts.js
import * as React from "react";
// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  RichTextField,
  SelectInput,
  ChipField,
  NumberField,
  SingleFieldList,
  ArrayInput,
  SimpleFormIterator,
  NumberInput,
  FormTab,
  TabbedForm,
  DateField,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";

const PotentialProjectFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="description" alwaysOn />
  </Filter>
);

const EntryTitle = ({ record }) => {
  return <span>Project: {record ? `${record.description}` : ""}</span>;
};

export const PotentialProjectListAdmin = (props) => (
  <List
    {...props}
    filters={<PotentialProjectFilter />}
    exporter={false}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField source="description" />
      <ReferenceArrayField label="Areas" reference="areas" source="areas">
        <SingleFieldList linkType={false}>
          <ChipField source="description" />
        </SingleFieldList>
      </ReferenceArrayField>
      <NumberField source="duration" />
      <RichTextField source="details" />
      <RichTextField source="requirements" />
      <DateField label="Last Update" source="lastupdate" locales="lt" />
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);
export const PotentialProjectList = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    filters={<PotentialProjectFilter />}
    exporter={false}
  >
    <Datagrid>
      <TextField source="description" />
      <ReferenceArrayField label="Areas" reference="areas" source="areas">
        <SingleFieldList linkType={false}>
          <ChipField source="description" />
        </SingleFieldList>
      </ReferenceArrayField>
      <NumberField source="duration" />
      <RichTextField source="details" />
      <RichTextField source="requirements" />
      <DateField label="Last Update" source="lastupdate" locales="lt" />
      <ShowButton label="" />
    </Datagrid>
  </List>
);

export const PotentialProjectShow = (props) => (
  <Show title={<EntryTitle />} {...props}>
    <TabbedForm redirect={false}>
      <FormTab label="Description">
        <TextField source="id" />
        <TextField source="description" />
        <NumberField source="duration" label="Duration (months)" />
        <NumberField source="budget" />
      </FormTab>
      <FormTab label="Areas">
        <ReferenceArrayField label="Areas" reference="areas" source="areas">
          <SingleFieldList linkType={false}>
            <ChipField source="description" />
          </SingleFieldList>
        </ReferenceArrayField>
      </FormTab>
      <FormTab label="Details">
        <RichTextField source="details" />
      </FormTab>
      <FormTab label="Requirements">
        <RichTextField source="requirements" />
      </FormTab>
      <FormTab label="Status">
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Show>
);

export const PotentialProjectCreate = (props) => (
  <Create {...props}>
    <TabbedForm redirect={false}>
      <FormTab label="Description">
        <TextInput source="id" label="Id" />
        <TextInput source="description" />
        <NumberInput source="duration" label="Duration (months)" />
        <NumberInput source="budget" />
      </FormTab>
      <FormTab label="Areas">
        <ArrayInput source="areas">
          <SimpleFormIterator>
            <ReferenceInput
              source="areas"
              reference="areas"
              sortBy="description"
            >
              <SelectInput optionText="description" />
            </ReferenceInput>
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>
      <FormTab label="Details">
        <RichTextInput source="details" />
      </FormTab>
      <FormTab label="Requirements">
        <RichTextInput source="requirements" />
      </FormTab>
    </TabbedForm>
  </Create>
);

export const PotentialProjectEdit = (props) => (
  <Edit title={<EntryTitle />} {...props}>
    <TabbedForm redirect={false}>
      <FormTab label="Description">
        <TextInput source="description" />
        <NumberInput source="duration" label="Duration (months)" />
        <NumberInput source="budget" />
      </FormTab>
      <FormTab label="Areas">
        <ReferenceArrayInput
          label="Areas"
          source="areas"
          reference="areas"
          perPage={100}
        >
          <SelectArrayInput optionText="description" />
        </ReferenceArrayInput>
      </FormTab>
      <FormTab label="Details">
        <RichTextInput source="details" />
      </FormTab>
      <FormTab label="Requirements">
        <RichTextInput source="requirements" />
      </FormTab>
      <FormTab label="Status">
        <NumberInput source="scoring" label="Scoring" />
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/potentialProjects.js